import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Helmet } from 'react-helmet';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { useTheme } from '../../../theming/useTheme';
import {
  MoreLinksComponentProps,
  MoreLinksProps,
  MoreLinksThemeProps,
} from '../../components/navigation/header/secondaryHeader/MoreLinks';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { ChevronIcon, Directions } from '../../components/navigation/header/ChevronIcon';
import { DropDownMenu } from '../../components/navigation/header/DropDownMenu';
import { secondaryHeaderHeight } from '../../components/navigation/header/header.utils';
import { H4, semanticCSS } from '../../../typography/semanticTags';
import { getStyleBySize } from '../../../typography/semanticTags/semanticTags.utils';

const componentConfigThemeKey = 'moreLinks';

export const getStyle = (titleColor: string) => {
  return StyleSheet.create({
    wrapper: {
      height: 'inherit',
      [MEDIA_BREAKPOINTS.LARGE]: {
        display: 'block',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        display: 'none',
      },
    },
    titleWrapper: {
      width: 'fit-content',
      height: `${secondaryHeaderHeight}px`,
      color: titleColor,
      textDecoration: 'none',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 'none',
      ':hover': {
        cursor: 'pointer',
      },
    },
    title: {
      height: '100%',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
    },
    text: {
      marginRight: '9px',
    },
  });
};
export const AMPMoreLinksComponent: React.FunctionComponent<MoreLinksComponentProps> = props => {
  const { titleColor, links, moreLinksText, pagePath, fontSizesStyles } = props;
  const titleStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: TYPOGRAPHY_SIZE.NORMAL, fontSizeMedium: TYPOGRAPHY_SIZE.NORMAL, fontSizeLarge: TYPOGRAPHY_SIZE.NORMAL });
  const style = getStyle(titleColor);
  return (
    <React.Fragment>
      <Helmet>
        <script async={undefined} custom-element="amp-accordion" src="https://cdn.ampproject.org/v0/amp-accordion-0.1.js" />
      </Helmet>
      <div className={css(style.wrapper)}>
        {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
        <amp-accordion id="accordion-more-links" disable-session-states={undefined}>
          <section>
            <H4 styles={semanticCSS(style.titleWrapper, titleStyle)}>
              <div className={css(style.title)}>
                <div className={css(style.text)}>{moreLinksText}</div>
                <ChevronIcon direction={Directions.DOWN} />
              </div>
            </H4>
            <DropDownMenu menuLinks={links} configThemeKey="moreLinks" activeEndpoint={pagePath} />
          </section>
          {/*
  // @ts-ignore TS2339: Property 'amp-accordion' does not exist on type 'JSX.IntrinsicElements'. */}
        </amp-accordion>
      </div>
    </React.Fragment>
  );
};

const mapThemeToProps = (theme: MoreLinksThemeProps) => (
  {
    titleColor: theme.titleColor,
    menuBackground: theme.menuBackground,
    linkColor: theme.linkColor,
    hoverColor: theme.hoverColor,
    fontSizesStyles: theme.fontSizesStyles,
  }
);

export const AMPMoreLinks = (props: MoreLinksProps) => {
  const themeContext = useTheme(mapThemeToProps, componentConfigThemeKey);
  return <AMPMoreLinksComponent {...themeContext} {...props} />;
};
